import { EventItemAttachment, NewsItemAttachment } from 'Types/emajinAPI'

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'avif']

function isImageUrl(url: string): boolean {
  try {
    const cleanUrl = url.split('?')[0]
    const extension = cleanUrl.split('.').pop()?.toLowerCase()

    return extension ? IMAGE_EXTENSIONS.includes(extension) : false
  } catch {
    return false
  }
}

function getAcceptableAttachment(
  attachments?: NewsItemAttachment[] | EventItemAttachment[],
) {
  return (
    attachments?.filter(item => {
      if (!item.url) return false
      if (item.title === item.id + '_video_preview') return false

      return isImageUrl(item.url)
    }) ?? []
  )
}

export default { getAcceptableAttachment }
